import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

const VillaFuegoPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleReserveClick = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const reserveSection = document.getElementById('reserve');
      if (reserveSection) {
        reserveSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const images = [
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/59b21acc2e58843c921781306305d80b.jpeg',
      alt: 'Villa Fuego warm exterior with sunset colors'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/60035933306509cb075fc56a3a5f44a1.jpeg',
      alt: 'Villa Fuego interior space'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/22b938a148c818e7e0bbba4739477003.jpeg',
      alt: 'Villa Fuego modern kitchen'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/226b7b41465532a48605a54676d55685.jpeg',
      alt: 'Villa Fuego comfortable bedroom'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/4ea7f93305a63c8060916f1cd6f49106.jpeg',
      alt: 'Villa Fuego outdoor terrace with dining area'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/5051f9f1bccdc0b8e7a201f8e758a93d.jpeg',
      alt: 'Villa Fuego elegant bedroom interior'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/710149e4aa6ae80310032c1e5d217fe7.jpeg',
      alt: 'Villa Fuego bright bedroom with colorful art'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/af77553e2baffb5086be1b13a70790da.jpeg',
      alt: 'Villa Fuego stylish bathroom'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/97333fce110890812596113f1b5fca47.jpeg',
      alt: 'Villa Fuego luxurious bathroom with marble details'
    },
    {
      url: 'https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/0dfda1f5f45b8840901a23b0b7748b99.jpeg',
      alt: 'Villa Fuego outdoor pool area'
    }
  ];

  return (
    <div className="min-h-screen">
      <Navigation />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative h-[60vh] min-h-[500px]">
          <img
            src={images[0].url}
            alt={images[0].alt}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent"></div>
          <div className="absolute inset-0 flex items-end">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 w-full">
              <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mb-4">
                Villa Fuego
              </h1>
              <p className="text-xl text-white/90 max-w-2xl">
                Ignite your passion and energy. Warm terracotta tones, outdoor fire pit, 
                and vibrant spaces for transformation and renewal.
              </p>
            </div>
          </div>
        </section>

        {/* Overview Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-serif font-bold text-gray-900 mb-6">
                  About Villa Fuego
                </h2>
                <div className="prose prose-lg text-gray-600 space-y-4">
                  <p>
                    Villa Fuego embodies the transformative energy of the fire element. This vibrant 
                    sanctuary features warm terracotta tones, passionate design elements, and spaces 
                    that inspire creativity and personal transformation.
                  </p>
                  <p>
                    The villa's design celebrates vitality and renewal, with an outdoor fire pit for 
                    evening gatherings, sun-drenched terraces, and bold artistic touches that ignite 
                    your inner flame. Every detail has been thoughtfully chosen to support your journey 
                    of empowerment and self-expression.
                  </p>
                  <p>
                    Perfect for those seeking to reignite their passion, embrace change, and step into 
                    their power, Villa Fuego offers an energizing retreat where you can truly transform 
                    and shine.
                  </p>
                </div>
              </div>

              <div className="bg-sand-50 rounded-2xl p-8">
                <h3 className="text-2xl font-serif font-bold text-gray-900 mb-6">
                  Villa Details
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <i className="ri-user-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Capacity</div>
                      <div className="text-gray-600">Sleeps 2-4 guests</div>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-hotel-bed-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Bedrooms</div>
                      <div className="text-gray-600">2 bedrooms</div>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-shower-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Bathrooms</div>
                      <div className="text-gray-600">2 full bathrooms</div>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-fire-line text-2xl text-primary-500 mr-3 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900">Outdoor Space</div>
                      <div className="text-gray-600">Private terrace with fire pit</div>
                    </div>
                  </div>
                </div>

                <button
                  onClick={handleReserveClick}
                  className="w-full mt-8 bg-primary-500 hover:bg-primary-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
                >
                  Reserve Villa Fuego
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Photo Gallery */}
        <section className="py-16 bg-sand-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-serif font-bold text-gray-900 mb-12 text-center">
              Photo Gallery
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {images.map((image, index) => (
                <div 
                  key={index}
                  className="relative h-80 rounded-2xl overflow-hidden shadow-lg group cursor-pointer"
                >
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Amenities Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-serif font-bold text-gray-900 mb-12 text-center">
              Amenities
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-wifi-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">High-Speed WiFi</h3>
                <p className="text-sm text-gray-600">Stay connected throughout your stay</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-temp-cold-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Air Conditioning</h3>
                <p className="text-sm text-gray-600">Climate control in all rooms</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-restaurant-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Full Kitchen</h3>
                <p className="text-sm text-gray-600">Fully equipped for meal preparation</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-parking-box-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Free Parking</h3>
                <p className="text-sm text-gray-600">Complimentary on-site parking</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-service-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Daily Housekeeping</h3>
                <p className="text-sm text-gray-600">Keep your space fresh and clean</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-cake-2-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Organic Breakfast</h3>
                <p className="text-sm text-gray-600">Healthy breakfast included daily</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-fire-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Outdoor Fire Pit</h3>
                <p className="text-sm text-gray-600">Evening gatherings under the stars</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-yoga-line text-4xl text-primary-500"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">Yoga Space Access</h3>
                <p className="text-sm text-gray-600">Shared yoga and meditation areas</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-primary-50 to-sand-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-serif font-bold text-gray-900 mb-6">
              Ready to Experience Villa Fuego?
            </h2>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Limited spots available for our upcoming retreats. Reserve your place in this 
              energizing sanctuary and begin your journey of transformation.
            </p>
            <button
              onClick={handleReserveClick}
              className="bg-primary-500 hover:bg-primary-600 text-white px-12 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              Reserve Your Spot
            </button>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default VillaFuegoPage;